import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router, RoutesRecognized } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, pairwise } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private history: string[] = [];

  private currentRoutePath = new BehaviorSubject<string>(undefined);

  private previousRoutePath = new BehaviorSubject<string>(undefined);

  constructor(
    private router: Router,
    private location: Location,
    private localStorageService: LocalStorageService
  ) {
    this.currentRoutePath.next(this.router.url);

    this.router.events
      .pipe(
        filter((e) => e instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((event: any[]) => {
        this.history.push(event[1].urlAfterRedirects);
        this.previousRoutePath.next(event[0].urlAfterRedirects);
        this.currentRoutePath.next(event[1].urlAfterRedirects);
      });
  }

  public getPreviousUrl(): Observable<string> {
    return this.previousRoutePath.asObservable();
  }

  public getCurrentUrl(): Observable<string> {
    return this.currentRoutePath.asObservable();
  }

  public setLoadDataSteps(resetDataSteps: boolean): void {
    const loadDataSteps = {
      stepTwo: true,
      stepThree: true,
      stepFour: true,
    };

    if (resetDataSteps) {
      loadDataSteps.stepTwo = false;
      loadDataSteps.stepThree = false;
      loadDataSteps.stepFour = false;
    }

    this.setFlagsLoadDataSteps(loadDataSteps);
  }

  public getFlagsLoadDataSteps() {
    return this.localStorageService.get('load_data_steps');
  }

  public setValueStepFlag(step: string, value: boolean = true) {
    const loadDataSteps = this.getFlagsLoadDataSteps();
    loadDataSteps[step] = value;

    this.setFlagsLoadDataSteps(loadDataSteps);
  }

  public getValueStepFlag(step: string) {
    const loadDataSteps = this.getFlagsLoadDataSteps();
    return loadDataSteps[step];
  }

  public setFlagsLoadDataSteps(value) {
    this.localStorageService.set('load_data_steps', value);
  }

  public back(): void {
    this.history.pop();

    if (this.history.length > 0) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/');
    }
  }
}
